import { render, staticRenderFns } from "./ds-order.vue?vue&type=template&id=79b5475c"
import script from "./ds-order.vue?vue&type=script&lang=js"
export * from "./ds-order.vue?vue&type=script&lang=js"
import style0 from "./ds-order.vue?vue&type=style&index=0&id=79b5475c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports